import {API_URL} from "../../constants/ConfigFromBuildEnvironment";
import HTTPRequestExecuter from "./HTTPRequestExecuter";
import EventPublisher from "../../utils/EventPublisher";
import ActionResultEvents from "../../constants/events/ActionResultEvents";

export default class PublicRequestExecuter {

    static executeGETRequest(route, requestParams, dataFromAction, responseHandler) {
        PublicRequestExecuter.sendGET(route, requestParams)
            .then((response) => responseHandler.handleResponse(response, dataFromAction))
            .catch(
                (error) =>
                    EventPublisher.publish(ActionResultEvents.SERVER_ERROR, {"error": error.toString()}));
    }

    static executePOSTRequest(route, requestParams, requestBody, dataFromAction, responseHandler) {
        PublicRequestExecuter.sendPOST(route, requestParams, requestBody)
            .then((response) => responseHandler.handleResponse(response, dataFromAction))
            .catch(
                (error) =>
                    EventPublisher.publish(ActionResultEvents.SERVER_ERROR, {"error": error.toString()}));
    }

    static sendGET(route, params) {
        return HTTPRequestExecuter.makeBodilessRequest(
            "GET",
            API_URL + route,
            params,
            {});
    }

    static sendPOST(route, params, body) {
        return HTTPRequestExecuter.makeRequest(
            "POST",
            API_URL + route,
            params,
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body);
    }

}